<template>
    <div>
      <el-tooltip v-if="visible" content="Histórico do de-para" placement="top">
        <el-button
          style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); padding: 1px; font-size: 16px;"
          type="primary"
          icon="el-icon-question"
          :circle="true"
          @click="abrirModal"
        ></el-button>
      </el-tooltip>
      <b-modal ref="modalhistorico" size="xl" title="Histórico" opt>
        <el-table
            class="p-table"
            :data="item"
            style="width: 100%"
            stripe
            border
            size="mini">
                <el-table-column
                    prop="tipo"
                    label="Tipo"
                    align="left">
                </el-table-column>
                <el-table-column
                    prop="nome"
                    label="Nome"
                    align="left">
                </el-table-column>
                <el-table-column
                    prop="info"
                    label="Info"
                    align="left">
                </el-table-column>
                <el-table-column
                    prop="dePara"
                    label="De-Para Anterior"
                    align="left">
                </el-table-column>
                <el-table-column
                    prop="usuario"
                    label="Usuário"
                    align="left">
                </el-table-column>
        </el-table>
        <template #modal-footer>
            <b-button @click="fecharModal" style="background-color: #769ec3;">OK</b-button>
        </template>
      </b-modal>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      visible: Boolean,
      options: Array
    },
    computed: {
        item() {
            return this.options || [];
        }
    },
    methods: {
        abrirModal() {
            this.$refs.modalhistorico.show();
        },
        fecharModal() {
            this.$refs.modalhistorico.hide();
        }
    },
  };
  </script>
  